// extracted by mini-css-extract-plugin
export default {"drawer":"drawer___zHRCq","title":"title___blXBY","main":"main___UOzrx","content":"content___YKouk"};